import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { FORCE_UPDATE } from '../../HOME/REDUX/actions';
import { delay, playSound, windowSize } from '../../HOME/utils';
import { IN_PILE, IN_PLAY, IN_TRAY, TO_PILE, TO_TRAY } from '../const';
import * as f from '../logic';
import { SELECT_TILE } from '../REDUX/actions';
import ShapeIcon from './ShapeIcon';
import { MODE_AI } from '../../HOME/const';

const Tile = ({ tile, style, over, doRefill, placeTile, save }) => {
  const dispatch = useDispatch();
  const { pn, common } = useSelector(state => state);
  const selected = f.sameOb(pn.selected, tile);
  const { shape, color, row, col, spot } = tile;
  const [l] = useState({ beat: 0 });
  const [scale, setScale] = useState(1);
  const scales = 1.75;

  const forceUpdate = () => dispatch({ type: FORCE_UPDATE });

  if (tile.status === IN_PLAY) {
    style = { ...style, gridArea: `${row}/${col}` };
  }

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const isPulse = () => {
    return selected || scale < 1 || (pn.over && l.beat < 6);
  };

  let dx = 0;
  let dy = 0;

  if (spot) {
    let e = document.getElementById(spot.id);

    if (e) {
      const r1 = e.getBoundingClientRect();

      e = document.getElementById(tile.id);

      if (e) {
        const r2 = e.getBoundingClientRect();

        dx = r1.x - r2.x;
        dy = r1.y - r2.y;
      }
    }
  }

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const transSpring = useSpring({
    transform: `translate(${dx}px, ${dy}px)`,
    config: { duration: 300 },
    onRest: () => spot && placeTile(tile, spot),
  });

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const pulseSpring = useSpring({
    transform: `scale(${isPulse() ? scales - scale : 1})`,
    onRest: () => {
      pn.over ? ++l.beat : (l.beat = 0);
      isPulse() && setScale(scales - scale);
    },
    config: { duration: 200 },
  });

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const refillSpring = useSpring({
    transform: 'translateY(0)',
    from: { transform: `translateY(-200px)` },
    onRest: () => {
      if (tile.status === TO_TRAY) {
        playSound(common, 'dice');
        tile.status = IN_TRAY;
        save();
      }
    },
    config: { duration: 200 },
    delay: _.random(200),
  });

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const clearSpring = useSpring({
    transform: `translateY(${tile.status === TO_PILE ? windowSize().y : 0}px)`,
    onRest: () => {
      if (tile.status === TO_PILE) {
        playSound(common, 'dice2');
        tile.status = IN_PILE;
        delay(() => {
          if (doRefill()) {
            delay(forceUpdate, 550);
          }
        }, 350);
      }
    },
    config: { duration: 500 },
    delay: _.random(300),
  });

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  const handleClick = () => {
    if (over || (pn.mode === MODE_AI && pn.turn === 2)) {
      return;
    }

    playSound(common, 'click');
    dispatch({ type: SELECT_TILE, selected: selected ? null : tile });
  };

  if (tile.status === IN_PILE) {
    return null;
  }

  const transform = isPulse()
    ? pulseSpring.transform
    : tile.status === TO_TRAY
    ? refillSpring.transform
    : tile.status === TO_PILE
    ? clearSpring.transform
    : spot
    ? transSpring.transform
    : 'initial';

  const zIndex = spot || tile.status === TO_PILE ? 2 : 0;

  //••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••
  return (
    <animated.div className="pn-tile" id={tile.id} style={{ ...style, transform, zIndex }} onClick={handleClick}>
      <ShapeIcon shape={shape} color={color} />
    </animated.div>
  );
};

export default Tile;
